var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QPageContainer',{staticClass:"desktop-single-column"},[_c('QPage',{class:{ 'q-px-md': _vm.padX, 'q-py-lg': _vm.padY }},[_vm._t("default")],2),(_vm.$slots.footer)?_c('QFooter',{class:[
      'flex justify-center bg-transparent',
      { 'q-pb-lg': _vm.padY, 'no-pointer-events': _vm.noFooterPointerEvents }
    ],attrs:{"reveal":_vm.revealFooter}},[_vm._t("footer")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }